<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      อัพเดทงานลูกค้า
    </div>
    <v-container>
      <div style="display: flex; flex-direction: row" class="mt-6">
        <div>
          <img style="height: 60px" :src="data.customer_profile_pic" />
        </div>
        <div style="align-self: center; margin-left: 20px; font-size: 14px">
          <span style="color: green">ชื่อ:</span> {{ data.customer_name }}
        </div>
      </div>
      <ValidationObserver ref="observer">
        <div class="mt-8">
          <ValidationProvider v-slot="{ errors }" name="รูปงาน" key="images">
            <upload-multiple-file
              v-model="images"
              :max="5"
              data-vv-name="uploadMultipleFile"
              data-vv-as="Preview Image"
            ></upload-multiple-file>

            <div v-if="errors && errors.length" class="v-text-field__details">
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">
                    {{ errors[0] }}
                  </div>
                </div>
              </div>
            </div>
          </ValidationProvider>
        </div>
        <div class="pt-5 updateprogress">
          <ValidationProvider
            v-slot="{ errors }"
            name="ข้อความถึงผู้จ้าง"
            rules="required"
            key="images"
          >
            <v-textarea
              v-model="input.message"
              outlined
              :error-messages="errors"
              name="input-7-4"
              placeholder="ส่งข้อความถึงผู้จ้าง"
            ></v-textarea>
          </ValidationProvider>
        </div>
      </ValidationObserver>
      <div class="text-center px-6">
        <v-btn
          @click="sendProgess"
          :loading="saveloading"
          :disabled="saveloading"
          block
          color="primary"
          outlined
        >
          <v-icon class="mr-2">mdi-image-move</v-icon>
          ยืนยันอัพเดทงาน</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
import UploadMultipleFile from "@/components/UpdateMultipleFileUpdateProgress.vue";
import axios from "axios";
export default {
  props: ["data", "value"],
  components: {
    UploadMultipleFile,
  },
  data() {
    return {
      saveloading: false,
      images: [],
      input: {
        message: "",
      },
    };
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    },
    query() {
      return this.$store.state.query;
    },
  },
  methods: {
    async sendProgess() {
      var vm = this;
      var isValid = await this.$refs.observer.validate();
      console.log(this.$store.state.show);
      if (isValid) {
        this.saveloading = true;
        var data = {
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
          order_number: this.data.order_number,
          message: this.input.message,
          imagelist: this.images, // array url ของรูป limit ใส่มาได้แค่ 5 รูป
        };
        axios
          .post(
            "https://communitybotbyzwizai.herokuapp.com/toadealersendupdatejob",
            data,
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            vm.saveloading = false;
            if (response.data.responsecode == 200) {
              await vm.$swal.fire({
                icon: "success",
                text: "สำเร็จ",
                confirmButtonText: "ตกลง",
              });
              var index = vm.$store.state.show.orderlist.findIndex(
                (el) => el.orderid == this.data.orderid
              );
              vm.$store.state.show.orderlist[index].history_update_job =
                response.data.data;
              this.$forceUpdate();
              vm.$emit("onSuccess");
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.updateprogress .v-text-field--outlined >>> fieldset {
  border-color: rgba(209, 209, 209, 0.986);
}
</style>